module.exports = __webpack_public_path__ + "static/logo_Mala_Czarna-41639ace385b3e8031b1827cad5d5095.png";